// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__35LBh","content":"styles_content__16aUy","intro":"styles_intro__1QmQ5"};